import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Reviewer } from './reviewer.model';
import { ReviewInvoice } from './review-invoice.model';
import { StructuredRating } from './submodels/structured-rating.model';

export const REVIEW_SCHEMA = Object.freeze({
  ID: '',
  CREATED_TIME: '',
  COMMENT: '',
  STAR_RATING: 0,
  REVIEWER: Reviewer,
  INVOICE: ReviewInvoice,
  STRUCTURED_RATINGS: StructuredRating,
});
export const RECORD = generateSchema(REVIEW_SCHEMA);
export const KEYS: any = generateKeys(REVIEW_SCHEMA);

export class Review extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.REVIEWER,
        value: props.get(KEYS.REVIEWER) ? new Reviewer(this.reviewer) : null,
      },
      {
        key: KEYS.INVOICE,
        value: props.get(KEYS.INVOICE) ? new ReviewInvoice(this.invoice) : null,
      },
      {
        key: KEYS.STRUCTURED_RATINGS,
        value: props.get(KEYS.STRUCTURED_RATINGS)
          ? new StructuredRating(this.structuredRatings)
          : null,
      },
    ]);

    return selfModel as Review;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get createdTime(): string {
    return this.get(KEYS.CREATED_TIME);
  }

  get comment(): string {
    return this.get(KEYS.COMMENT);
  }

  get starRating(): number {
    return this.get(KEYS.STAR_RATING);
  }

  get reviewer(): Reviewer {
    return this.get(KEYS.REVIEWER);
  }

  get invoice(): ReviewInvoice {
    return this.get(KEYS.INVOICE);
  }

  get structuredRatings(): StructuredRating {
    return this.get(KEYS.STRUCTURED_RATINGS);
  }
}
